export const SaleOfferStatus = Object.freeze({
    P: Symbol('P'),
    A: Symbol('A'),
    S: Symbol('S'),
    C: Symbol('C'),
});

export function getStatusText(status) {
    return {
        [SaleOfferStatus.P]: 'Do zatwierdzenia',
        [SaleOfferStatus.A]: 'Aktywna',
        [SaleOfferStatus.S]: 'Sprzedana',
        [SaleOfferStatus.C]: 'Anulowana'
    }[SaleOfferStatus[status]];
}